import { Container } from '../components/Container';
import { SectionHeading } from '../components/SectionHeading';
import type { LandingContent } from '../content/types';
import { sectionIds } from '../lib/routes';

type ProcessSectionProps = {
  content: LandingContent;
};

export function ProcessSection({ content }: ProcessSectionProps) {
  return (
    <section className="section" id={sectionIds.process} aria-labelledby="process-title">
      <Container>
        <SectionHeading id="process-title" title={content.process.h2} />
        <div className="process-list">
          {content.process.steps.map((step, index) => (
            <article className="process-step" key={step.title}>
              <span aria-hidden="true">{String(index + 1).padStart(2, '0')}</span>
              <div>
                <h3>{step.title}</h3>
                <p>{step.text}</p>
              </div>
            </article>
          ))}
        </div>
      </Container>
    </section>
  );
}
